export const environments = {
  development: 'development',
  production: 'production',
  test: 'test',
} as const;
